import { StoreState } from '../types';

import { LastBookingsState } from './types';

export const getLastBookingsState = (state: StoreState): LastBookingsState =>
  state.lastBookings;
